import React, { useState } from "react"

import { Link } from "react-router-dom"
import { toast } from "sonner"

import Icon from "@/components/Icon"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useAuth } from "@/contexts/AuthContext"

const Login = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const { signIn } = useAuth()
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      // Simple validation
      if (!email || !password) {
        toast.error("Login failed", { description: "Please enter both email and password" })
        setIsLoading(false)
        return
      }

      // Use the AuthContext's signIn function which handles permission-based redirects
      const { error } = await signIn(email, password)

      if (error) {
        toast.error("Login failed", { description: error.message })
      }
      // No need to handle successful login here as it's handled in AuthContext
    } catch (error) {
      console.error("Login error:", error)
      toast.error("Login failed", { description: "An unexpected error occurred" })
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <div className="min-h-screen bg-palette-jungleGreen000 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          alt="DriverHive"
          className="mx-auto h-12"
          src="/images/b324345a-d7f5-4435-8a45-ce025baae0be.png"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-palette-jungleGreen900">
          Sign in to your account
        </h2>
        <p className="mt-2 text-center text-sm text-palette-jungleGreen600">Access the dashboard</p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleLogin}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-palette-jungleGreen700"
              >
                Email
              </label>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Icon name="envelope" className="h-5 w-5 text-palette-jungleGreen400" />
                </div>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  placeholder="you@example.com"
                  className="pl-10"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-palette-jungleGreen700"
                >
                  Password
                </label>
                <Link
                  to="/forgot-password"
                  className="text-sm font-medium text-palette-jungleGreen700 hover:underline"
                >
                  Forgot password?
                </Link>
              </div>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Icon name="lock" className="h-5 w-5 text-palette-jungleGreen400" />
                </div>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  placeholder="Password"
                  className="pl-10"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <div>
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading ? "Signing in..." : "Sign in"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export default Login
